module.exports = __webpack_public_path__ + "static/img/atom.44b390ca.png";